/* eslint-disable no-magic-numbers */
import React from 'react';
import { Option, Select } from 'carbon-react/lib/components/select';

import { useIntl } from '@futrli/localisation';

import { adaptSelectChange } from '../../../../utils/carbon-select';

import { QuickActionsType } from '../../types';

interface QuickActionsMenuProps {
  className?: string;
  disabled?: boolean;
  marginRight?: number;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: QuickActionsType;
  size?: 'small' | 'medium' | 'large';
}

export const QuickActionsMenu = ({
  disabled = false,
  onChange,
  value,
  marginRight = 16,
  size = 'large'
}: QuickActionsMenuProps) => {
  const intl = useIntl();

  return (
    <div style={{ width: 225, marginRight }}>
      <Select
        data-testid="QuickActionsMenu"
        autoComplete="off"
        onChange={adaptSelectChange(onChange)}
        value={value ?? ''}
        label={intl.formatMessage({
          id: 'predict.quick_actions',
          defaultMessage: 'Quick actions'
        })}
        disabled={disabled}
        size={size}
        mb={0}
      >
        <Option
          value={QuickActionsType.setSelectedTo}
          text={intl.formatMessage({ id: 'predict.set_selected_to', defaultMessage: 'Set selected to' })}
        />
        <Option
          value={QuickActionsType.increaseByPercentage}
          text={intl.formatMessage({
            id: 'predict.increase_by_percentage',
            defaultMessage: 'Increase by percentage'
          })}
        />
        <Option
          value={QuickActionsType.decreaseByPercentage}
          text={intl.formatMessage({
            id: 'predict.decrease_by_percentage',
            defaultMessage: 'Decrease by percentage'
          })}
        />
        <Option
          value={QuickActionsType.increaseByAmount}
          text={intl.formatMessage({ id: 'predict.increase_by_amount', defaultMessage: 'Increase by amount' })}
        />
        <Option
          value={QuickActionsType.decreaseByAmount}
          text={intl.formatMessage({ id: 'predict.decrease_by_amount', defaultMessage: 'Decrease by amount' })}
        />
        <Option
          value={QuickActionsType.splitBetweenSelected}
          text={intl.formatMessage({
            id: 'predict.split_between_selected',
            defaultMessage: 'Split between selected'
          })}
        />
      </Select>
    </div>
  );
};
